import { Link } from "react-router-dom";
import { Home, Building2, Factory, Warehouse, Landmark, Map, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { TiltCard } from "@/components/TiltCard";
import { WHAT_BUILDING } from "@/data/content";

const ICONS = { Home, Building2, Factory, Warehouse, Landmark, Map };

export const WhatAreYouBuilding = () => (
    <section id="build" data-testid="what-building-section" className="paper-grid relative overflow-hidden py-24 lg:py-32">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
            <SectionHeading
                id="what-building-heading"
                overline="Start Here"
                title={<>What are <span className="text-flame-dark">you</span> building?</>}
                description="One ecosystem — from a single home to a master-planned township. Choose your path and see exactly how OMSIVO handles it."
            />
            <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {WHAT_BUILDING.map((c, i) => {
                    const Icon = ICONS[c.icon];
                    return (
                        <Reveal key={c.slug} delay={0.05 * i} className="h-full">
                            <TiltCard testid={`build-card-${c.slug}`} className="h-full">
                                <Link to={`/services/${c.slug}`}
                                    className="group flex h-full flex-col rounded-2xl border border-omsivo-navy/10 bg-white p-7 transition-colors hover:border-flame/60 focus-visible:outline-2 focus-visible:outline-flame">
                                    <div className="flex items-start justify-between">
                                        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-omsivo-navy/5 text-omsivo-blue transition-colors group-hover:bg-flame group-hover:text-white">
                                            <Icon className="h-6 w-6" />
                                        </div>
                                        <ArrowUpRight className="h-5 w-5 text-slate-300 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-flame" />
                                    </div>
                                    <h3 className="mt-6 font-display text-xl font-extrabold uppercase tracking-[0.05em] text-omsivo-navy">{c.title}</h3>
                                    <p className="mt-2 text-sm leading-relaxed text-slate-600">{c.text}</p>
                                    <span className="mt-auto pt-5 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-omsivo-blue transition-colors group-hover:text-flame-dark">
                                        Explore {c.title}
                                    </span>
                                </Link>
                            </TiltCard>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
